<template>
  <div>
    <div class="page" v-if="row">
      <!--店员信息-->
      <div style="display: flex;margin-bottom: 20px">
        <div style="width: 40%;">
          <ClerkInfo type="object" :info="row.myClerkInfo"/>
          <div style="margin-left: 5px" v-if="row.status===3">
            <van-tag v-if="!row.isDraw&&row.winnerId===row.myClerkInfo.id" plain type="warning">胜利</van-tag>
            <van-tag v-else-if="!row.isDraw&&row.winnerId!==row.myClerkInfo.id" plain type="danger">失败</van-tag>
            <van-tag v-else plain>平局</van-tag>
          </div>
        </div>
        <div class="pk">
          <div class="icon">
            <img src="/static/images/default/PK.png">
          </div>
          <div class="amount">
            <span style="color: red">{{ divide100(row.myClerkInfo.amount) }}</span>
            <span>VS</span>
            <span style="color: red">{{ divide100(row.pkClerkInfo.amount) }}</span>
          </div>
        </div>
        <div style="width: 40%;">
          <ClerkInfo type="object" :info="row.pkClerkInfo"/>
          <div style="margin-left: 5px" v-if="row.status===3">
            <van-tag v-if="!row.isDraw&&row.winnerId===row.pkClerkInfo.id" plain type="warning">胜利</van-tag>
            <van-tag v-else-if="!row.isDraw&&row.winnerId!==row.pkClerkInfo.id" plain type="danger">失败</van-tag>
            <van-tag v-else plain>平局</van-tag>
          </div>
        </div>
      </div>
      <div>
        <div>
          <span style="color: grey;margin: 5px">状态：</span>
          <van-tag v-if="row.status === 0"  plain type="danger" >等待中</van-tag>
          <van-tag v-if="row.status === 1" plain type="primary" >进行中</van-tag>
          <van-tag v-if="row.status === 2" plain type="warning" >统计中</van-tag>
          <van-tag v-if="row.status === 3" plain type="success" >已完成</van-tag>
        </div>
      </div>

      <div>
        <div style="color: grey;margin: 5px">创建:{{ formatDate(row.createTime, 'YYYY-MM-DD HH:mm') }}</div>
        <div style="color: grey;margin: 5px">开始:{{ formatDate(row.startTime, 'YYYY-MM-DD HH:mm') }}</div>
        <div style="color: grey;margin: 5px">结束：{{ formatDate(row.endTime, 'YYYY-MM-DD HH:mm') }}</div>
        <div v-if="row.isDoubleIncome" style="color: grey;margin: 5px">PK分数翻倍：{{ formatDate(row.doubleIncomeStartTime, 'YYYY-MM-DD HH:mm')}}-{{formatDate(row.doubleIncomeEndTime, 'YYYY-MM-DD HH:mm')}}</div>

        <div style="color: grey;margin: 5px">结果公示结束：{{ formatDate(row.penaltyEndTime, 'YYYY-MM-DD HH:mm') }}</div>
      </div>

    </div>
    <div>
      <div style="text-align: center;border-top: 1px solid grey; border-bottom: 1px solid grey;">
        <div style="display: flex;justify-content: space-around;text-align: center;">
          <div style="width: 60%">
            <div style="background: #f8f8f9;padding: 5px;font-size: 15px;border-bottom: 1px solid white">PK明细</div>
          </div>
          <div style="width: 30%">
            <div style="background: #f8f8f9;padding: 5px;font-size: 15px;border-bottom: 1px solid white">PK分数</div>
          </div>
        </div>
      </div>
      <van-list
          v-model="loading"
          :finished="listFinished"
          finished-text="没有更多了"
          @load="loadDataList">
        <div v-for="(item, index) in list" :key="index" style="text-align: center;border-bottom: 1px solid grey;">
          <div style="display: flex;justify-content: space-around;text-align: center;">
            <div style="width: 60%">
              <div class="clerk-container">
                <div class="item">
                  <img :src="item.headImgUrl" class="avatar">
                  <div class="line">
                    <div>
                      <div style="display: flex;">{{ item.nickname }}</div>
                      <div>{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm:ss') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 30%">
              <div class="clerk-container">
                <div class="item">
                  <div class="line">
                    <div>
                      <div>{{ formatPrice(item.rewardValue) }}</div>
                      <div v-if="item.isDoubleIncome">
                        <van-tag plain size="large" color="red">PK分数翻倍</van-tag>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, List, Tag,  Cell, } from "vant"
import moment from "moment";
import {handlePromise} from "@/libs/util";
import {getPKInfo, getPKInfoList} from "../../../api/clerk/clerk-pk";
import Decimal from "decimal.js";
import ClerkInfo from '@/components/ClerkInfo';

Vue.use(List)
    .use(Cell)
    .use(Tag)


export default {
  name: "clerk-pk-info",
  components: {
    ClerkInfo,
  },
  data() {
    return {
      row:null,
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10,
      list: [],
    }
  },

  methods: {
    divide100(amount) {
      return Decimal.div(amount, 100).toNumber()
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    loadData() {
      handlePromise(getPKInfo(this.$route.params.id), (data) => {
        this.row=data.clerkPkInfo
      }, (data) => {
        this.loading = false
        Dialog.alert({title: '加载失败', message: data.msg})
      })
    },
    loadDataList(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
        this.list = []
      }
      this.loading = true
      getPKInfoList(this.$route.params.id, this.pageNo, this.pageSize).then((res) => {
        this.loading = false
        const data = res.data
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false;
          } else {
            this.listFinished = true;
          }
        } else {
          this.listFinished = true;
          Dialog.alert({title: '加载失败', message: data.msg})
        }
        this.pageNo++
      })
    },
    /** 金额格式化 */
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toNumber()
      }
      return '0'
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped lang="less">
.page {
  padding: 2vw 4vw 0;
  margin-top: 20px;
  box-sizing: border-box;

  .list {

    .listItem {
      padding: 2.6vw 0;

    }
  }


  .pk {
    align-items: center;
    margin-top: 20px;
    text-align: center;

    .icon {
      img {
        width: 30px;
        height: 30px;
        margin: 0 10px;
        border-radius: 50%;
      }
    }

    .amount {

    }
  }
}
.clerk-container {
  display: flex;
  justify-content: center;

  .item {
    display: flex;
    align-items: center;
    padding: 20px 0;

    .avatar {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      border-radius: 50%;
    }

    .line {
      line-height: 25px;
    }
  }
}
</style>
